import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/drift",
      name: "drift",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Drift.vue")
    },
    {
      path: "/kontakt",
      name: "kontakt",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Kontakt.vue")
    },
    {
      path: "/tjanster",
      name: "tjanster",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Tjanster.vue")
    },
    {
      path: "/kundcase",
      name: "kundcase",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Kundcase.vue")
    },{
      path: "/singlecase/:slug",
      name: "singlecase",
      props: true,
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/SingleCase.vue")
    },{
      path: "/nsva",
      name: "nsva",
      props: true,
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Nsva.vue")
    },{
      path: "/ekologigruppen",
      name: "ekologigruppen",
      props: true,
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Ekologigruppen.vue")
    },{
      path: "/Falgfixarna",
      name: "Falgfixarna",
      props: true,
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Falgfixarna.vue")
    },
    {
      path: "/om",
      name: "om",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Om.vue")
    },
    {
      path: "/support",
      name: "support",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Support.vue")
    },
    { path: '*',
      component: () =>
          import(/* webpackChunkName: "about" */ "./views/404.vue")
    }
  ]
});
